import React from 'react'
import { Box, Typography } from '@mui/material'

const SaleTerm = () => {
  return (
    <Box sx={{
      mt: 10,
      px: {
        xs: 2,
        md: 5,
        lg: 5
      },
      mb: {
        xs: 0,
        md: 5,
        lg: 10
      }
    }}>

      <Typography variant='h4' sx={{ textAlign: "center", fontWeight: "bolder", mb: 3 }}>SALE TERMS & CONDITIONS</Typography>
      <Box sx={{ backgroundColor: "#F7FBFF", py: 4, px: 3 }}>

        <Typography variant='body2' sx={{ mb: 2 }}>
          <Typography component="span" sx={{ fontWeight: "400", mb: 2 }}>
            These Terms & Conditions (“Agreement”) govern the sale of fashion products and services by AMBER.
          </Typography>
          By making a purchase on our website, you agree to comply with and be bound by these Terms & Conditions.
        </Typography>

        <Typography variant='body2' sx={{ fontWeight: "400", mb: 2 }}>1. General Terms</Typography>
        <Typography variant='body2' sx={{ mb: 2 }}>
          By placing an order, you confirm that you are at least 18 years of age or have received parental consent.
          We reserve the right to change or update these Terms & Conditions at any time without prior notice, and all updates will be posted on our website.
        </Typography>

        <Typography variant='body2' sx={{ fontWeight: "400", mb: 2 }}>2. Product Information</Typography>
        <Typography variant='body2' sx={{ mb: 2 }}>
          We make every effort to ensure that product descriptions, including sizes, colors, and materials, are accurate.
          However, slight variations may occur due to display settings, lighting, or other technical factors.
          Product images on the website are for reference only and may differ slightly from the actual products.
        </Typography>

        <Typography variant='body2' sx={{ fontWeight: "400", mb: 2 }}>3. Pricing and Payment</Typography>
        <Typography variant='body2' sx={{ mb: 2 }}>
          All prices are listed in MYR and are subject to change without notice.
          We accept the following payment methods: credit cards, PayPal, Apple Pay, etc.
          Payment is processed at the time of order. By submitting an order, you authorize us to charge your chosen payment method.
          If an item is incorrectly priced, we reserve the right to cancel or adjust the order.
        </Typography>

        <Typography variant='body2' sx={{ fontWeight: "400", mb: 2 }}>4. Shipping & Delivery</Typography>
        <Typography variant='body2' sx={{ mb: 2 }}>
          <strong>Shipping Rates:</strong> Shipping costs are calculated at checkout based on the delivery address and selected shipping method.
          <br /><strong>Processing Time:</strong> Orders are typically processed within 2 to 7 business days. Custom-made or pre-order items may take longer.
          <br /><strong>Shipping Time:</strong> Estimated delivery times are provided at checkout. Delivery times may vary based on the shipping method chosen and your location.
          <br /><strong>International Shipping:</strong> We offer international shipping to select countries. International orders may be subject to additional customs duties, taxes, and fees, which are the buyer’s responsibility.
          <br /><strong>Order Tracking:</strong> Once your order is shipped, you will receive a tracking number via email.
        </Typography>

        <Typography variant='body2' sx={{ fontWeight: "400", mb: 2 }}>5. Returns & Exchanges</Typography>
        <Typography variant='body2' sx={{ mb: 2 }}>
          <strong>Return Window:</strong> We accept returns within 7 days of delivery. Items must be returned in their original, unworn condition with tags attached.
          <br /><strong>Exceptions:</strong> Certain products such as sale items may not be eligible for exchange.
          <br /><strong>Process:</strong> To initiate a return, please contact us at admin@amberofficials.com.my with your order number and reason for return.
          <br /><strong>Refunds:</strong> Strictly no refund is not allowed.
          <br /><strong>Exchanges:</strong> If you wish to exchange an item for a different size or color, please contact us to arrange the exchange.
        </Typography>

        <Typography variant='body2' sx={{ fontWeight: "400", mb: 2 }}>6. Discounts, Promotions, and Offers</Typography>
        <Typography variant='body2' sx={{ mb: 2 }}>
          Promotional discounts, sales, or offers may apply to specific items or orders. These discounts are valid only during the promotion period and cannot be combined with other offers unless stated.
          Coupons or promo codes must be applied at checkout. We are not responsible for expired or forgotten promo codes.
          We reserve the right to modify, suspend, or terminate any promotion at our discretion.
        </Typography>

        <Typography variant='body2' sx={{ fontWeight: "400", mb: 2 }}>7. Account Responsibility</Typography>
        <Typography variant='body2' sx={{ mb: 2 }}>
          When creating an account, you agree to provide accurate and up-to-date information. You are responsible for maintaining the confidentiality of your account and password.
          Please notify us immediately if you believe there has been any unauthorized use of your account.
          We reserve the right to suspend or terminate any accounts that violate our terms or engage in fraudulent activities.
        </Typography>

        <Typography variant='body2' sx={{ fontWeight: "400", mb: 2 }}>8. Intellectual Property</Typography>
        <Typography variant='body2' sx={{ mb: 2 }}>
          All content on this website, including text, images, logos, graphics, and designs, are the property of AMBER and are protected by intellectual property laws.
          You may not copy, reproduce, distribute, or use any content from our website without our express written permission.
        </Typography>

        <Typography variant='body2' sx={{ fontWeight: "400", mb: 2 }}>9. Limitation of Liability</Typography>
        <Typography variant='body2' sx={{ mb: 2 }}>
          We are not liable for any indirect, incidental, or consequential damages arising from the use or inability to use our website or products.
          Our total liability to you is limited to the amount paid for the product(s) in question.
        </Typography>

        <Typography variant='body2' sx={{ fontWeight: "400", mb: 2 }}>10. Privacy & Data Protection</Typography>
        <Typography variant='body2' sx={{ mb: 2 }}>
          We value your privacy. Please refer to our Privacy Policy for details on how we collect, use, and protect your personal data.
        </Typography>

        <Typography variant='body2' sx={{ fontWeight: "400", mb: 2 }}>11. Force Majeure</Typography>
        <Typography variant='body2' sx={{ mb: 2 }}>
          We are not liable for any failure or delay in the performance of our obligations due to circumstances beyond our control, including acts of God, natural disasters, pandemics, strikes, or supply chain disruptions.
        </Typography>

        <Typography variant='body2' sx={{ fontWeight: "400", mb: 2 }}>12. Governing Law & Dispute Resolution</Typography>
        <Typography variant='body2' sx={{ mb: 2 }}>
          These Terms & Conditions are governed by the laws of Malaysia. Any disputes or claims will be resolved in the competent courts of Kuala Lumpur.
        </Typography>
      </Box>
    </Box>
  )
}

export default SaleTerm